<template>
	<div>
        <div class="modal fade" id="mdBaixarTitulosPagar" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Baixa de títulos à pagar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-9 col-md-9 col-lg-9">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialbaixarec" v-model="vcodfilbaixa" data-placeholder="Selecionar filial" data-allow-clear="true" style="width:100%; font-weight: bold;"></select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtpagamento">Dt. Pagamento</label>
                                <div class="input-group date campodata" id="eddtpagamento">
                                    <input type="text" id="eddtpagamento" v-model="vdtbaixa" class="form-control form-control-sm" disabled/>
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="col-sm-12 col-md-9 col-lg-9">
                                <label for="ednomefornecedorbaixa">Nome do fornecedor</label>
                                <input type="text" class="form-control form-control-sm" v-model="vfornecedorbaixa" id="ednomefornecedorbaixa" data-bv-group=".group" maxlength="50" disabled/>
                            </div> -->
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvalortotalbaixa">Total</label>
                                <money class="form-control form-control-sm" id="edvalortotaltit" v-bind="money" v-model="vvariaveisbaixarcmp.vtottitbaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edtotalmultabaixa">Total multa</label>
                                <money class="form-control form-control-sm" id="edtotalmultabaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotmultabaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edpercdesctojurosbaixa">Desc. Juros(%)</label>
                                <money class="form-control form-control-sm" id="edpercdesctojurosbaixa" v-bind="money" v-model="percdescontojuros" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvldesctojurosbaixa">Vl. Desc Juros</label>
                                <money class="form-control form-control-sm inputs-valores" id="edvldesctojurosbaixa" v-bind="money" v-model="valdescontojuros" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edtotaljurosbaixa">Total juros</label>
                                <money class="form-control form-control-sm" id="edtotaljurosbaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotjurosbaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvalorpagarbaixa">Valor a pagar</label>
                                <money class="form-control form-control-sm" id="edvalorpagarbaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotpagarbaixa" data-bv-group=".group" style="text-align:right; color: #337ab7; font-weight: bold;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edpercdescmultabaixa">Desc. Multa(%)</label>
                                <money class="form-control form-control-sm" id="edpercdescmultabaixa" v-bind="money" v-model="percdescontomulta" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvldesctomultabaixa">Vl. Desc Multa</label>
                                <money class="form-control form-control-sm inputs-valores" id="edvldesctomultabaixa" v-bind="money" v-model="valdescontomulta" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="txtobs">Observações</label>
                                <textarea class="form-control center" rows="2" v-model="obsbaixatit" id="txtobs" style="text-transform: uppercase;"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-2 col-md-3 col-lg-3" id="dvvalorrecebimento">
                                    <label for="edvalorrecebimento">Total do pagamento</label>
                                    <money class="form-control form-control-sm inputs-valores" id="edvalorrecebimento" v-bind="money" v-model="vvltotalrecebimento" data-bv-group=".group" style="text-align:right;"></money>
                                </div>                                
                                <div class="col-sm-2 col-md-3 col-lg-3">
                                    <span class="lblselect2">Perfil do fluxo:</span>
                                    <select id="cbperfilfluxo" v-model="aidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>                                
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <a href="#" role="button" class="btn btn-success btn-sm" data-toggle="modal" id="btbaixartitulo" @click.prevent="mtdconfirmarbaixa()" name="btbaixartitulo" style="width:100%; margin-top: 20px;"><i class="fa fa-check"></i> Confirmar baixa dos títulos</a>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 20px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
	import util from '../utilitarios/util.js'
	export default {
        name : "cmpbaixartitulospagar",
        props: [
            'vdtbaixa',
            //'vfornecedorbaixa',
            'vvariaveisbaixarcmp',
            'propvaldescontojuros',
            'propvaldescontomulta',
            'proplstselecionados'
        ],       			
		data : function () {
			return {
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais,
                vcodfilbaixa            : null,
                percdescontojuros       : 0,
                percdescontomulta       : 0,
                valdescontojuros        : 0,
                valdescontomulta        : 0,
                vvltotalrecebimento     : 0,
                vcompararecebimento     : 0,
                obsbaixatit             : '',

                //rotina fluxo caixa
                vidperfilfluxo          : null,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',     //aqui colocar o cifrão se for necessário
                    precision: 2,
                    masked: false
                }                
            }
         },
		methods: {
			formatavalor(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },
            arredondavalores(val, casas) {
                return util.arredondaValores( val, casas, 'round' );
            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},                        
            mtdiniciar_def_cmp_btr(){
                let vself         = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

                $("#cbfilialbaixarec").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodfilbaixa = $("#cbfilialbaixarec").val();
                });

                $("#cbperfilfluxo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxo = $("#cbperfilfluxo").val();
                });                
            },
            mtdconfirmarbaixa() {
                let vself = this;
                if (vself.vcodfilbaixa === null){
                    vself.$toastr.w('Filial da baixa do título deve ser informada!', 'Atenção!');
                    $("#cbfilialbaixarec").focus();
                    return;
                }
                if (parseFloat(vself.vvltotalrecebimento) > parseFloat(vself.vvariaveisbaixarcmp.vtotpagarbaixa)){
                    vself.$toastr.w('Valor informado para baixa maior que o valor à pagar!', 'Atenção!');
                    $("#edvalorrecebimento").focus();                    
                    return;
                }
                if (vself.vvltotalrecebimento > 0){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma baixa do(s) título(s)?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdbaixar();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#edvalorrecebimento").focus();
                                }
                            }
                        }
                    });
                }else{
                    vself.$toastr.w('Informe um valor válido para o pagamento!', 'Atenção!');
                    $("#edvalorrecebimento").focus();
                }
            },
            mtdbaixar(){
                let vself  = this;
                let loader = vself.$loading.show();
                let dadosbaixa = {
                    'dtbaixa'               : vself.vdtbaixa,
                    'percdescontojuros'     : vself.percdescontojuros,
                    'percdescontomulta'     : vself.percdescontomulta,
                    'vltotalrecebimento'    : vself.vvltotalrecebimento,
                    'obsbaixatit'           : vself.obsbaixatit,
                    'titulosbaixar'         : vself.proplstselecionados,
                    'idfilialbaixa'         : vself.vcodfilbaixa,
                    'idperfilfluxo'         : vself.vidperfilfluxo === null ? 0 : vself.vidperfilfluxo
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'baixar'},
                    {parametro: 'dadosbaixa',   valor : JSON.stringify(dadosbaixa)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '030Z.010Z.040Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        $('#mdBaixarTitulosPagar').modal('hide');
                        vself.$toastr.s('Títulos baixados com sucesso!', 'Informação!');
                        //dispara a mutation pra executar a pesquisa do resultado da baixa
                        let payload = {
                            retorno    : 1
                        };
                        vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);                        
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    $('#mdBaixarTitulosPagar').modal('hide');
                });                                
            }                                    
        },
        mounted: function () { 
            let vself = this;
            $("#mdBaixarTitulosPagar").on('show.bs.modal', function () {
                //limpa variaveis
                vself.percdescontojuros     = 0;
                vself.percdescontomulta     = 0;
                vself.vvltotalrecebimento   = 0;
                vself.vcompararecebimento   = 0;

                var deffilialbaixa = new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
                $('#cbfilialbaixarec').append(deffilialbaixa).trigger('change');
            });
            $("#mdBaixarTitulosPagar").on('shown.bs.modal', function () {
                $("#edpercdesctojurosbaixa").focus();
            });
            $('#edvldesctojurosbaixa').blur(function(){
                let rValorJuros       = 0;
                let rPercDesc         = 0;
                rValorJuros           = vself.valdescontojuros;

                if(vself.vvariaveisbaixarcmp.vtotjurosbaixa > 0)
                {
                    rPercDesc          = (1 - (rValorJuros / vself.vvariaveisbaixarcmp.vtotjurosbaixa)) * 100;
                }else{
                    rPercDesc          = 0;
                }
                vself.percdescontojuros                     = rPercDesc;
                vself.vvariaveisbaixarcmp.vvalorrecebimento = vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa;
            });
            $('#edvldesctomultabaixa').blur(function(){
                let rValorMulta       = 0;
                let rPercDesc         = 0;
                rValorMulta           = vself.valdescontomulta;

                if(vself.vvariaveisbaixarcmp.vtotmultabaixa > 0)
                {
                    rPercDesc          = (1 - (rValorMulta / vself.vvariaveisbaixarcmp.vtotmultabaixa)) * 100;
                }else{
                    rPercDesc          = 0;
                }
                vself.percdescontomulta                     = rPercDesc;
                vself.vvariaveisbaixarcmp.vvalorrecebimento = vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa;
            });                         
            this.mtdiniciar_def_cmp_btr();     
        },
        computed: {
        },
        watch:{
            percdescontojuros() {
                let rJuros                                 = 0;
                rJuros                                     = this.vvariaveisbaixarcmp.vtotjurosbaixa * (1-(this.percdescontojuros/100));
                this.valdescontojuros                      = rJuros;
                this.vvariaveisbaixarcmp.vvalorrecebimento = this.valdescontojuros + this.valdescontomulta + this.vvariaveisbaixarcmp.vtottitbaixa;
            },
            propvaldescontojuros() {
                this.valdescontojuros = this.propvaldescontojuros;
            },
            propvaldescontomulta() {
                this.valdescontomulta = this.propvaldescontomulta;
            },
            percdescontomulta() {
                let rMulta                                 = 0;
                rMulta                                     = this.vvariaveisbaixarcmp.vtotmultabaixa * (1-(this.percdescontomulta/100));
                this.valdescontomulta                      = rMulta;
                this.vvariaveisbaixarcmp.vvalorrecebimento = this.valdescontojuros + this.valdescontomulta + this.vvariaveisbaixarcmp.vtottitbaixa;
            }            
        }
	}
</script>
<style>
</style>